import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBug } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BAlert, BButton, BCard } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed, onMounted, ref } from "vue";
import { GalaxyApi } from "@/api";
import { fetchDatasetDetails } from "@/api/datasets";
import {} from "@/api/jobs";
import { useConfig } from "@/composables/config";
import { useMarkdown } from "@/composables/markdown";
import { useUserStore } from "@/stores/userStore";
import localize from "@/utils/localization";
import { errorMessageAsString } from "@/utils/simple-error";
import DatasetErrorDetails from "@/components/DatasetInformation/DatasetErrorDetails.vue";
import FormElement from "@/components/Form/FormElement.vue";
import GalaxyWizard from "@/components/GalaxyWizard.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatasetError',
    props: {
        datasetId: null
    },
    setup(__props) {
        const props = __props;
        library.add(faBug);
        const userStore = useUserStore();
        const { currentUser, isAnonymous } = storeToRefs(userStore);
        const { renderMarkdown } = useMarkdown({ openLinksInNewPage: true });
        const { config, isConfigLoaded } = useConfig();
        const message = ref("");
        const jobLoading = ref(true);
        const errorMessage = ref("");
        const datasetLoading = ref(false);
        const jobDetails = ref();
        const jobProblems = ref();
        const resultMessages = ref([]);
        const dataset = ref();
        const showForm = computed(() => {
            const noResult = !resultMessages.value.length;
            const hasError = resultMessages.value.some((msg) => msg[1] === "danger");
            return noResult || hasError;
        });
        const showWizard = computed(() => isConfigLoaded && config.value?.llm_api_configured && !isAnonymous.value);
        async function getDatasetDetails() {
            datasetLoading.value = true;
            try {
                const data = await fetchDatasetDetails({ id: props.datasetId });
                dataset.value = data;
            }
            catch (e) {
                errorMessage.value = errorMessageAsString(e) || "Unable to fetch available dataset details.";
            }
            finally {
                datasetLoading.value = false;
            }
        }
        async function getJobDetails(jobId) {
            jobLoading.value = true;
            try {
                const { data, error } = await GalaxyApi().GET("/api/jobs/{job_id}", {
                    params: {
                        path: { job_id: jobId },
                        query: { full: true },
                    },
                });
                if (error) {
                    errorMessage.value = errorMessageAsString(error) || "Unable to fetch job details.";
                    return;
                }
                jobDetails.value = data;
            }
            finally {
                jobLoading.value = false;
            }
        }
        async function getJobProblems(jobId) {
            const { data, error } = await GalaxyApi().GET("/api/jobs/{job_id}/common_problems", {
                params: {
                    path: { job_id: jobId },
                },
            });
            if (error) {
                errorMessage.value = errorMessageAsString(error) || "Unable to fetch job problems.";
                return;
            }
            jobProblems.value = data;
        }
        async function submit(dataset, userEmailJob) {
            if (!dataset) {
                errorMessage.value = "No dataset found.";
                return;
            }
            const { data, error } = await GalaxyApi().POST("/api/jobs/{job_id}/error", {
                params: {
                    path: { job_id: dataset.creating_job },
                },
                body: {
                    dataset_id: dataset.id,
                    message: message.value,
                    email: userEmailJob,
                },
            });
            if (error) {
                errorMessage.value = errorMessageAsString(error);
                return;
            }
            resultMessages.value = data.messages;
        }
        function onMissingJobId() {
            errorMessage.value = "No job ID found for this dataset.";
        }
        onMounted(async () => {
            await getDatasetDetails();
            const creatingJobId = dataset.value?.creating_job;
            if (!creatingJobId) {
                onMissingJobId();
                return;
            }
            await getJobDetails(creatingJobId);
            await getJobProblems(creatingJobId);
        });
        return { __sfc: true, props, userStore, currentUser, isAnonymous, renderMarkdown, config, isConfigLoaded, message, jobLoading, errorMessage, datasetLoading, jobDetails, jobProblems, resultMessages, dataset, showForm, showWizard, getDatasetDetails, getJobDetails, getJobProblems, submit, onMissingJobId, faBug, FontAwesomeIcon, BAlert, BButton, BCard, localize, DatasetErrorDetails, FormElement, GalaxyWizard };
    }
});
